import { MenuItem } from '@material-ui/core'
import { useEffect, useMemo } from 'react'

import InputText from '@/components/input-text'

import { SearchTypesComponentsProps } from '..'
import { useStyles } from '../styles'

export function StatusSearchField({
  value,
  onChange,
}: SearchTypesComponentsProps) {
  const classes = useStyles()

  const defaultValue = useMemo(() => value, [])

  useEffect(() => {
    if (!value) onChange('registered')
  }, [])

  return (
    <InputText
      aria-label='Campo de busca por status'
      defaultValue={defaultValue}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      select
      SelectProps={{
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
          classes: { paper: classes.menuList },
          elevation: 0,
        },
      }}
    >
      <MenuItem className={classes.menuItem} value='registered'>
        Cadastrado
      </MenuItem>
      <MenuItem className={classes.menuItem} value='processing'>
        Processando
      </MenuItem>
      <MenuItem className={classes.menuItem} value='completed'>
        Concluído
      </MenuItem>
      <MenuItem className={classes.menuItem} value='rejected'>
        Recusado
      </MenuItem>
      <MenuItem className={classes.menuItem} value='reported'>
        Analisar
      </MenuItem>
    </InputText>
  )
}
